import { createApp } from 'vue';
import { createPinia } from 'pinia';
import '@shiocast/ui/styles';
import { installDensity } from '@shiocast/ui';
import App from './App.vue';
import { router } from './router';
import { i18n, setLocale, type Locale } from './i18n';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(i18n);

// Sets the document language as well as the message catalogue. Without the attribute a
// screen reader pronounces Dutch with an English voice, which is worse than useless.
setLocale(i18n.global.locale.value as Locale);

// Density is a per-device operator preference; applying it here means every surface
// picks it up without each component asking.
installDensity();

app.mount('#app');
